import { c as _c } from "react/compiler-runtime";
import "@google/model-viewer";
import { BaseNFT } from "@/entities/INFT";
export default function NFTModel(props) {
  const $ = _c(5);
  const t0 = props.id ?? `iframe-${props.nft.id}`;
  const t1 = props.nft.metadata.animation ?? props.nft.metadata.animation_url;
  let t2;
  if ($[0] !== props.nft.name || $[1] !== props.nft.scaled || $[2] !== t0 || $[3] !== t1) {
    t2 = <model-viewer id={t0} src={t1} alt={props.nft.name} auto-rotate={true} camera-controls={true} ar={true} poster={props.nft.scaled} />;
    $[0] = props.nft.name;
    $[1] = props.nft.scaled;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}